<template>
    <v-card outlined class="pa-4">
        <v-card-title class="card-home-title">Lembretes</v-card-title>
        
        <v-card-text>
            <v-tabs v-model="tab">
                <v-tab>Hoje</v-tab>
                <v-tab>Amanhã</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-list style="max-height: 300px; min-height: 300px;" two-line class="mt-2">
                        <v-list-item
                        v-for="alert in today.data"
                        :key="alert.alerta_id"
                        >
                            <v-list-item-content>
                            <v-list-item-title v-text="'Projeto #' + alert.projeto.projeto_id"></v-list-item-title>

                            <v-list-item-subtitle style="white-space: break-spaces;" v-text="alert.alerta_descricao" class="mt-2"></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-tab-item>

                <v-tab-item>
                    <v-list two-line style="max-height: 300px; min-height: 300px;" class="mt-2">
                        <v-list-item
                        v-for="alert in tomorrow.data"
                        :key="alert.alerta_id"
                        >
                            <v-list-item-content>
                            <v-list-item-title v-text="'Projeto #' + alert.projeto.projeto_id"></v-list-item-title>

                            <v-list-item-subtitle style="white-space: break-spaces;" v-text="alert.alerta_descricao" class="mt-2"></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
    </v-card>
</template>

<script>
import AlertaService from '../../../services/AlertaService'

export default {
    name: 'project-alert-card',
    data: () => ({
        tab: null,
        today: [],
        tomorrow: []
    }),
    computed: {
        service () {
            return new AlertaService;
        }
    },
    methods: {
        async getAlerts() {
            this.today = await this.service.getAll({
                alerta_disparo: [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)]
            })

            this.tomorrow = await this.service.getAll({
                alerta_disparo: [
                    new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10), 
                    new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
                ]
            })
        }
    },
    created () {
        this.getAlerts()
    }
}
</script>
